(function ($, Drupal) {
  Drupal.behaviors.animations = {
    attach: function (context, settings) {
      // if (context !== document) {
      //   return;
      // }

      const elements = document.querySelectorAll('.animate-on-scroll');
      if (elements && elements.length) {
        elements.forEach((element) => {
          let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.3,
          };

          let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('show-animation');
              }
            });
          }, options);

          observer.observe(element);
        });
      }
    }
  };

})(jQuery, Drupal);
